<template>
  <div>
    <loader :loader="sending" />
    <template>
      <patient-information :model="model" @patientLoaded="handlePatientLoaded"/>
      <patient-interpretation-appo-info :model="model" />
      <study-background :parameters="model" />
      <interpretation-options :sending="sending" :reported="reported" :withBirads="withBirads"
        :buttonBirads="buttonBirads" :model="model" :modelDialog="modelDialog" @ReportedValue="ReportedValue"
        @validBiradsEmit="validBiradsEmit" />
      <interpretation-interpretations :model="model" :changeTemplateInterpretation="changeTemplateInterpretation"
        :isPDF="isPDF" :downloadViewer="downloadViewer" :downloadZIP="downloadZIP" :viewerOsirix="viewerOsirix"
        :downloadInterpretation="downloadInterpretation" :sending="sending" :reported="reported"
        :validBirads="validBirads" :loadingImages="loadingImages" :listTemplates="listTemplates"
        @seeOrHideViewer="seeOrHideViewer" :images="images" :addImages="addImages" :saveTemplate="saveTemplate"
        :modelDialog="modelDialog" :fillinterpretation="fillinterpretation"
        :fillSaveTemplate="fillSaveTemplate"
        :dialogViewer="dialogViewer" :addImageToList="addImageToList"
        :closeSliderSaveTemp="closeSliderSaveTemp" :mastography="mastography" :listAllTemplates="listAllTemplates" />
      <v-expand-transition>
        <v-row v-if="dialogViewer" align="center" justify="center" class="d-flex flex-wrap text-center mb-2">
          <v-col class="col-md-2" v-for="(file, index) in images" :key="index" :id="index">
            <v-icon type="button" size="50px" color="error" @click="openPDF(file)">mdi-file-pdf-box</v-icon>
            <h3 style="text-align: center" class="mt-2 mb-2">
              Ver informe {{ index + 1 }}
            </h3>
          </v-col>
        </v-row>
      </v-expand-transition>
      <v-row align="center" justify="center" class="mt-5">
        <v-col cols="12" md="12" sm="12" class="mb-5">
          <PersonalAntecedents :model="model.colposcopy" :cols="6" :dense="true" />
        </v-col>
        <v-col cols="12">
          <h3 class="font-weight-black mb-5">Interpretación</h3>
        </v-col>
        <v-col v-if="allowCopyPaste">
          <validation-provider v-slot="{ errors }" name="diagnostico" rules="required">
            <vue-editor v-model="interpretation" required :error-messages="errors"
              :disabled="reported || sending"></vue-editor>
          </validation-provider>
        </v-col>
        <v-col v-if="!allowCopyPaste" @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
          <validation-provider v-slot="{ errors }" name="diagnostico" rules="required">
            <vue-editor v-model="interpretation" required :error-messages="errors"
              :disabled="reported || sending"></vue-editor>
          </validation-provider>
        </v-col>
      </v-row>


      <v-row align="center" justify="start" class="mt-5">
        <v-col cols="12" md="12" sm="12" >
          <v-row align="start" justify="start">

            <v-col :md="isMammography ? '6' : '12' " sm="12" >
              <h3 class="font-weight-black">Conclusión</h3>

              <v-col cols="12" v-if="!allowCopyPaste" @click.right.prevent @copy.prevent @paste.prevent
                ondrop="return false;">
                <validation-provider v-slot="{ errors }" name="conclusión" rules="required">
                  <vue-editor v-model="model.complement.conclusion" required :error-messages="errors"
                    @input="enabledButtonDownload"
                    :disabled="reported || sending"></vue-editor>
                </validation-provider>
              </v-col>
              <v-col cols="12" v-if="allowCopyPaste">
                <validation-provider v-slot="{ errors }" name="conclusión" rules="required">
                  <vue-editor v-model="model.complement.conclusion" required :error-messages="errors"
                    @input="enabledButtonDownload"
                    :disabled="reported || sending"></vue-editor>
                </validation-provider>
              </v-col>
            </v-col>
            <v-col v-if="isColposcopy" :md="isMammography ? '6' : '12'" sm="12">
              <h3 class="font-weight-black mb-4">Impresión diagnóstica</h3>
              <v-col cols="12" v-if="!allowCopyPaste" @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
                <validation-provider v-slot="{ errors }" name="diagnosticimpression" rules="required">
                  <vue-editor v-model="model.complement.diagnosticImpression" required
                    :error-messages="errors" @input="enabledButtonDownload"
                    :disabled="reported || sending">
                  </vue-editor>
                </validation-provider>
              </v-col>
              <v-col cols="12" v-if="allowCopyPaste">
                <validation-provider v-slot="{ errors }" name="diagnosticimpression" rules="required">
                  <vue-editor v-model="model.complement.diagnosticImpression" required
                    :error-messages="errors" @input="enabledButtonDownload"
                    :disabled="reported || sending">
                  </vue-editor>
                </validation-provider>
              </v-col>
            </v-col>
            <v-col md="5" sm="12" v-if="isMammography">
              <h3 class="font-weight-black mb-4">Conducta a seguir</h3>
              <v-row dense>
                <v-col cols="12">
                  <label>
                   Realizar toma de ultrasonido: 
                    <v-icon class="ml-4" @click="model.complement.ultrasound = null">
                    {{ $cnst.CLEAR_ICON }}
                  </v-icon> 
                  </label>
                  <v-radio-group  dense row
                    v-model="model.complement.ultrasound">
                    <v-radio label="SI" :value="true"></v-radio>
                    <v-radio label="NO" :value="false"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <validation-provider v-slot="{ errors, valid }" name="Próxima detección por mastografía en años" rules="">
                <v-autocomplete label="Próxima detección por mastografía en años:"
                  v-model="model.complement.nextDetection" :error-messages="errors" required
                  :clear-icon="$cnst.CLEAR_ICON" clearable :items="periods">
                  <v-icon slot="append" :color="valid ? 'success' : ''">
                    {{ valid && model.complement.nextDetection ? " mdi-check" : "mdi-chevron-down" }}
                  </v-icon>
                </v-autocomplete>
              </validation-provider>

              <v-row>
                <v-col cols="12">
                  <label>
                    Referencia a ginecología a tratamiento de patología benigna 
                    <v-icon class="ml-4" @click="model.complement.hasReference = null">
                    {{ $cnst.CLEAR_ICON }}
                  </v-icon> 
                  </label>
                  <v-radio-group  dense row
                    v-model="model.complement.hasReference">
                    <v-radio label="SI" :value="true"></v-radio>
                    <v-radio label="NO" :value="false"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- <v-checkbox class=" mb-4" v-model="model.complement.hasReference"
                :input-value="model.complement.hasReference ? 1 : 0"
                label="Referencia a ginecología a tratamiento de patología benigna">
              </v-checkbox> -->

              <validation-provider v-slot="{ errors, valid }" name="Referencia a evaluación diagnóstica a unidad"
                rules="max:200">
                <v-text-field label="Referencia a evaluación diagnóstica a unidad" :counter="200" maxlength="200"
                  v-model.trim="model.complement.referenceEvaluation" clearable :error-messages="errors" dense
                  :clear-icon="$cnst.CLEAR_ICON">
                  <v-icon slot="append" :color="valid ? 'success' : ''">
                    {{ valid && model.complement.referenceEvaluation ? " mdi-check" : "" }}
                  </v-icon>
                </v-text-field>
              </validation-provider>

              <validation-provider v-slot="{ errors, valid }" name="Fecha de referencia" v-if="model.complement.referenceEvaluation || $utilFront.isNonNull(model.complement.hasReference)">
                <v-text-field class="mt-8" v-model.trim="model.complement.referenceDate" label="Fecha de referencia"
                  autocomplete="off" dense clearable disabled
                  :error-messages="errors" :clear-icon="$cnst.CLEAR_ICON" type="text">
                  <v-icon slot="append" :color="valid ? 'success' : ''">
                    {{ valid && model.complement.referenceDate ? " mdi-check" : "" }}
                  </v-icon>
                </v-text-field>
              </validation-provider>

            </v-col>

          </v-row>

        </v-col>

      </v-row>

      <v-row align="center" justify="center" class="mb-4 mt-4">
        <v-col cols="6">
          <v-row align="center" justify="center">
            <v-col cols="8">
              <validation-provider v-slot="{ errors }" name="adjuntar archivos" rules="maxSizeFile">
                <v-file-input
                  v-model="localFiles"
                  @change="handleFileChange($event)"
                  placeholder="Seleccione los archivos"
                  label="Adjuntar archivos"
                  multiple
                  show-size
                  counter
                  prepend-icon="mdi-paperclip"
                  :disabled="reported"
                  :error-messages="errors">
                </v-file-input>
              </validation-provider>
            </v-col>
          </v-row>
        
          

          
<v-row class="d-flex flex-nowrap" align="start" justify="center">
  <v-col
    cols="2"
    class="text-center"
    v-for="(file, index) in addendums"
    :key="index"
  >
    <div class="d-flex flex-column justify-center">
      <div class="d-flex justify-end">
        <v-btn icon @click="confirmDeleteExistingFile(file)" :disabled="reported">
          <v-icon size="24px" color="error">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-icon
        style="font-size: 11vh; text-align: center"
        size="100px"
        :color="file.type === 'pdf' ? 'error' : (file.type === 'jpeg' ? 'secondary' : 'grey')"
      >
        {{ file.type === 'pdf' ? 'mdi-file-pdf-box' : (file.type === 'jpeg' ? 'mdi-image' : 'mdi-file') }}
      </v-icon>

      <h1 style="font-size: 120%; text-align: center">
        {{ file.name }}
      </h1>
      <v-btn text small @click="viewFile(file)" style="background-color: #4caf50; color: #000;">
        Ver
      </v-btn>
    </div>
  </v-col>
</v-row>

        </v-col>
      </v-row>
    </template>
    <v-dialog v-model="swalDialog" persistent></v-dialog>
  </div>
</template>

<script>
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientInterpretationAppoInfo from "@/app/components/interpretation/PatientInterpretationAppoInfo.vue";
import StudyBackground from "@/app/components/interpretation/StudyBackground.vue";
import InterpretationOptions from "@/app/components/interpretation/InterpretationOptions.vue";
import InterpretationInterpretations from "@/app/components/interpretation/InterpretationInterpretations.vue";
import InterpretationReportDialog from "@/app/components/interpretation/InterpretationReportDialog.vue";
import PersonalAntecedents from "@/app/components/optometry/common/PersonalAntecedents.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import {
  ReportPDFRequest,
  StudyRequest,
  DownloadZipRequest,
  InterpretationHistoryRequest,
} from "@/core/request";
import { InterpretationHistoryService } from "@/app/services";
import { TemplateDialogService } from "@/app/services";
import ConfigurationService from "@/app/services/ConfigurationService";
import { UtilFront } from "@/core/";

import { ValidationProvider } from "vee-validate";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    PatientInformation,
    PatientInterpretationAppoInfo,
    StudyBackground,
    InterpretationOptions,
    InterpretationInterpretations,
    InterpretationReportDialog,
    PersonalAntecedents,
    ValidationProvider,
    VueEditor,
    Loader,
  },
  props: {
    model: Object,
    modelDialog: Object,
    buttonBirads: Boolean,
    saveFilesChanges: Boolean,
    mastography: Boolean,
    isMammography: Boolean,
  },
  data() {
    return {
      files: [],
      filesRaw: [],
      sending: false,
      invalidSign: true,
      reported: false,
      withBirads: false,
      loadingImages: false,
      validBirads: false,
      dialogViewer: false,
      menu: false,
      listTemplates: [],
      images: [],
      imagesToAdd: [],
      mapping: [],
      addendums: [],
      colposcopyData: [],
      localFiles: [],
      swalDialog: false,
      fillinterpretation: false,
      fillSaveTemplate: false,
      closeSliderSaveTemp: false,
      allowCopyPaste: false,
      interpretation: null,
      complementInit: {
        conclusion: null,
        diagnosticImpression: null,
        nextDetection: null,
        hasReference: null,
        referenceEvaluation: null,
        referenceDate: null,
        ultrasound: null
      },
      periodsBirads:[
        {text: "6 MESES", value: "6 MESES", birads: ["3"]},
        {text: "1 AÑO",value: "1 AÑO", birads: ["0","1","2","3","4","5","6"]},
        {text: "2 AÑOS",value: "2 AÑOS", birads: ["0","1","2","3","4","5","6"]},
      ],
      periods: [
      ],
      flag: 0
    };
  },
  async mounted() {
    this.listAllTemplates();
    this.findAllImagesByStudy();
    this.specialCharacter();
    this.setDatafromModel();
    this.validBirads = this.$utilFront.nonEmpty(this.model.birads);
    this.findConfigurationCopyPaste();
    this.formatDate();
    this.validPeriodsBirads();
    this.setValues();
    if (this.isColposcopy) {
      await this.loadColposcopyFiles();
    }
    
  },
  watch: {
    saveFilesChanges(newVal) {
    if (newVal) {
      this.$emit('filesSelected', this.filesRaw);

      this.localFiles = [];
      this.filesRaw = [];
      this.files = [];
    }
  },

    interpretation: function () {
      this.enabledButtonDownload();
      this.enableButtonTemplate();
    },
    'model.colposcopyFiles': {
    immediate: true,
    handler(newVal) {
      if (Array.isArray(newVal)) {
        this.addendums = newVal.map(file => ({
          fileName: file.fileName,
          base64: file.base64,
          name: file.fileName,
          type: this.getFileType(file.fileName)
        }));
      } else {
        this.addendums = [];
      }
    }
  },
  interpretation (html) {
    this.model.interpretation = html
  },
  },
  computed: {
  isColposcopy() {
    return this.model.nameModality && this.model.nameModality.toUpperCase() === 'COLPOSCOPIA';
  }
},
  methods: {
    handleFileChange() {
      this.filesRaw = Array.from(this.localFiles);

      this.files = this.localFiles.map(file => ({
        name: file.name,
        type: file.type
      }));
    },
    async loadColposcopyFiles() {
      try {
        this.sending = true;
        const payload = { idStudy: this.model.idStudy };
        const res = await StudyRequest.papanicolaouViewReport(payload);
        const files = res.data.studyFiles;

        if (!files || files.length === 0 || !files[0].bytes) {
      return;
    }

        this.addendums = files.map(f => ({
          fileName: f.fileName,
          base64:   f.bytes,
          name:     f.fileName,
          type:     this.getFileType(f.fileName)
        }));
        // Este emit se pasa al padre InterpretationView para que se carguen los archivos viejos
        this.$emit('colposcopyFilesLoaded', files);
      } catch (e) {
        this.$utilFront.errorhttp(e);
      } finally {
        this.sending = false;
      }
    },

    // Helper para obtener el tipo de archivo
    getFileType(fileName) {
      const ext = fileName.split(".").pop().toLowerCase();
      return ext;
    },
  removeNewFile(index) {
    if (
      this.model.colposcopyFilesNew &&
      this.model.colposcopyFilesNew.length > index
    ) {
      this.model.colposcopyFilesNew.splice(index, 1);
    }
  },
    getFileType(fileName) {
    const extension = fileName.split('.').pop().toLowerCase();
    return extension;
  },
  deleteNewFile(fileName) {
  const idx = this.files.findIndex(f => f.name === fileName);
  if (idx > -1) this.files.splice(idx, 1);
},
    validPeriodsBirads(){
      let currentBirads = this.model?.birads?.name;
      this.periods = this.periodsBirads.filter(item => 
          this.$utilFront.isNull(currentBirads) || 
          item.birads.some(birad => currentBirads.includes(birad))
      );
      if(this.$utilFront.isNonNull(this.model.complement) && this.$utilFront.nonEmpty(this.model.complement.nextDetection)){
        let valueSelected = this.model.complement.nextDetection;
        if(!this.periods.some(period=> period.value === valueSelected)){
          this.$utilFront.notifications(`${valueSelected} no disponible en campo próxima detección.`, "ERROR" );
          this.model.complement.nextDetection = null;
        }
      }
    },
    setValues(){
      if(this.isMammography){
        this.model.complement.referenceDate = this.$utilFront.formatDate(this.model.registrationDateInterpretation, 1);
      }
    },
    enabledButtonDownload(){
      const textOne = (this.$utilFront.nonEmpty(this.interpretation) ? this.interpretation : "").replace(/<.*?>/g, "").replace(/\s+/g, "");
      const textTwo = (this.$utilFront.isNonNull(this.model.complement) ? (this.model.complement.conclusion || ""): "").replace(/<.*?>/g, "").replace(/\s+/g, "");
      this.fillinterpretation = this.$utilFront.nonEmpty(textOne.trim()) && this.$utilFront.nonEmpty(textTwo.trim());
    },
    enableButtonTemplate(){
      const textOne = (this.$utilFront.nonEmpty(this.interpretation) ? this.interpretation : "").replace(/<.*?>/g, "").replace(/\s+/g, "");
      this.fillSaveTemplate = this.$utilFront.nonEmpty(textOne.trim()) 
    },
    formatDate() {
    },
    findConfigurationCopyPaste() {
      ConfigurationService.findConfigurationCopyPasteInterpretation({ idBranchOffice: null }).then((response) => {
        let { data, status } = response;
        this.allowCopyPaste = data?.allowCopyPaste || false;
      }).catch(this.catchError)
        .finally(() => { });
    },
    deleteFile(fileName) {
      let i = this.files.findIndex((index) => index.name === fileName);
      if (i > -1) {
        this.files.splice(i, 1);
      }
    },
    deleteFileLocal(file) {
  if (this.model.colposcopyFiles) {
    this.model.colposcopyFiles = this.model.colposcopyFiles.filter(a => a.fileName !== file.fileName);
  }
  this.addendums = this.addendums.filter(a => a.fileName !== file.fileName);
},

confirmDeleteExistingFile(file) {
    this.swalDialog = true;
    this.$swal({
      toast: true,
      title: "¿Desea eliminar el documento?",
      icon: "warning",
      confirmButtonText: "Confirmar",
      showCancelButton: true,
      cancelButtonText: "No",
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
    }).then((result) => {
      this.swalDialog = false;
      if (!result.value) return;

      if (this.isColposcopy) {
        // Se elimina el archivo localmente del arreglo
        this.addendums = this.addendums.filter(a => a.fileName !== file.fileName);
        // model.colposcopyFiles se actualiza igual
        if (Array.isArray(this.model.colposcopyFiles)) {
          this.model.colposcopyFiles = this.model.colposcopyFiles
            .filter(a => a.fileName !== file.fileName);
        }
      } else {
        // Servicio que elimina los archivos de otro estudios
        this.deleteFileService(file);
      }
    });
  },

  base64ToBlob(base64, mimeType = 'application/pdf') {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length)
      .fill(0)
      .map((_, i) => byteChars.charCodeAt(i));
    return new Blob([new Uint8Array(byteNumbers)], { type: mimeType });
  },

  viewFile(file) {
    let b64;

    if (file.base64) {
      b64 = file.base64;

    } else if (typeof file.bytes === 'string') {
      b64 = file.bytes;

    } else if (Array.isArray(file.bytes)) {
      b64 = btoa(
        file.bytes.map(byte => String.fromCharCode(byte)).join('')
      );
    }

    if (b64) {
      const blob = this.base64ToBlob(b64, 'application/pdf');
      const url  = URL.createObjectURL(blob);
      window.open(url, '_blank');
      return;
    }

    if (file.url) {
      window.open(file.url, '_blank');
      return;
    }

    this.$utilFront.notifications('No pude encontrar datos para este archivo', 'ERROR');
  },

  deleteFileService(item) {
    const data = {
      fileName: item.fileName,
      idInterpretation: this.model.idInterpretation,
    };
    InterpretationHistoryRequest
      .deleteOneAddendum(data)
      .then((res) => {
        if (res.data.status === "OK" && res.data.data === true) {
          this.$utilFront.notifications("Archivo eliminado correctamente", "SUCCESS");
          this.addendums = this.addendums.filter(a => a.fileName !== item.fileName);
        } else {
          this.$utilFront.notifications("Error al eliminar el archivo", "ERROR");
        }
      })
      .catch(() => {
        this.$utilFront.errorhttp();
      });
  },
    setDatafromModel() {
      this.interpretation = this.model.interpretation;
    },
    specialCharacter() {
      let from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
        to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";

      for (let i = 0, j = from.length; i < j; i++) {
        this.mapping[from.charAt(i)] = to.charAt(i);
      }
    },
    /**emits */
    ReportedValue(value) {
      this.reported = value;
    },
    seeOrHideViewer(value) {
      this.dialogViewer = value;
    },
    validBiradsEmit(value, biradsSelected) {
      this.$emit("ActiveButtonSave", value);
      this.validBirads = value;
      this.validPeriodsBirads();
    },
    /** */
    async setFilesToModel() {
      // let filesList = [];
      // if (this.files != null && this.files.length != 0) {
      //   for (let file of this.files) {
      //     const value = await this.getBase64(file);
      //     filesList.push(value);
      //   }
      // }
      this.model.filesList = this.files;
      this.model.interpretation = this.interpretation;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        try {
          let reader = new FileReader();
          //for (let file of files) {
          reader = new FileReader();
          let fileByte = [];
          reader.readAsArrayBuffer(file);
          reader.onload = (evt) => {
            if (evt.target.readyState == FileReader.DONE) {
              let arrayBuffer = evt.target.result,
                array = new Uint8Array(arrayBuffer);
              for (let byte of array) {
                fileByte.push(byte);
              }
            }
            let c = "";
            for (var i = 0, j = file.name.length; i < j; i++) {
              var l = file.name.charAt(i);
              c = c + (l in this.mapping ? this.mapping[l] : l);
            }
            let te = c.replace(/[^a-zA-Z0-9-_+{}()&$!#%. ]/g, "");
            let f = {
              bytes: fileByte,
              fileName: te,
              type: file.type,
            };
            //this.filesToSave.push(f);
            resolve(f);
          };
          reader.onerror = function (error) {
            this.$utilFront.notifications(
              "Error al procesar archivo: " + file.name,
              "ERROR"
            );
          };
          //}
          reader.onloadend = (end) => {
            //this.add();
          };
        } catch (e) {
        } finally {
        }
      });
    },
    deleteFileService(file) {
  let data = {
    fileName: file.fileName,
    idInterpretation: this.model.idInterpretation,
  };
  InterpretationHistoryRequest.deleteOneAddendum(data)
    .then((res) => {
      if (res.data.status === "OK" && res.data.data === true) {
        this.addendums = this.addendums.filter((a) => a.fileName !== file.fileName);

        this.findAllImagesByStudy(); 
      }
    })
},
    findAllImagesByStudy() {
      let data = {
        idStudy: this.model.idStudy,
      };
      let params = {
        idInterpretation: this.model.idInterpretation,
      };
      this.loadingImages = true;
      StudyRequest.findAllImagesByStudy(data)
        .then((res) => {
          let data = res.data;
          this.images = data.data;
        })
        .finally(() => {
          this.loadingImages = false;
        });
      InterpretationHistoryService.getAddendums(params)
        .then((res) => {
          let { data, status, code } = res.data;
          if (code == 200 && typeof data === "object") {
            this.addendums = data;
            this.addendums.map((addendum) => {
              addendum.name = addendum.fileName;
            });
          }
        })
        .catch(() => {
          this.catchError();
        })
        .finally(() => {
          this.sending = false;
        });
    },
    listAllTemplates() {
      this.listTemplates = [];
      let params = {
        // idPerson: this.$utilFront.getIdPerson(),
        idModality: this.model.idModality,
      };
      TemplateDialogService.listAllTemplates(params)
        .then((res) => {
          let { data, status } = res;
          if (Array.isArray(data)) {
            this.listAllTemplatesToTable = data;
            this.listTemplates = data.map((obj) => {
              return {
                value: obj,
                text: obj.name + " (" + obj.idTemplateInterpretation + ")",
              };
            });
          } else {
            this.$utilFront.notifications(
              "Error al listar las plantillas.",
              "ERROR"
            );
          }
        })
        .catch(this.catchError)
        .finally(() => { });
    },
    saveTemplate() {
      this.sending = true;
      let regex = /<img[^>]*>/g;
      let text = this.interpretation.replaceAll(regex, "");
      let data = {
        templateHTML: text,
        name: this.modelDialog.nameTemplate,
        type: this.modelDialog.typeTemplate,
        // idHumanResource: this.$utilFront.getIdHumanResource(),s
        idModality: this.model.idModality,
      };
      TemplateDialogService.add(data)
        .then((res) => {
          let { data, status, statusText } = res;
          this.modelDialog.nameTemplate = "";
          this.modelDialog.typeTemplate = null;
          this.$utilFront.notifications(
            "Plantilla registrada correctamente.",
            "SUCCESS"
          );
          this.listAllTemplates();
          this.dialog = false;
          this.closeSliderSaveTemp = true;

        })
        .catch(this.catchError)
        .finally(() => {
          this.closeSliderSaveTemp = false;
          this.sending = false;
        });
    },
    changeTemplateInterpretation(eventtl) {
      if (eventtl != null) {
        let setTemplate = eventtl.templateHTML;
        setTemplate = setTemplate
          .replaceAll("<div>", "<p>")
          .replaceAll("</div>", "</p>");
        this.interpretation = setTemplate;
      } else {
        this.interpretation = "";
      }
    },
    isPDF() {
      return (
        this.model.acronymModality == "ECG" ||
        this.model.acronymModality == "DXA"
      );
    },
    downloadViewer(item) {
      try {
        this.sending = true;
        let data = {
          idStudy: item.idStudy,
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
        };
        StudyRequest.findURLJNLP(data)
          .then((res) => {
            window.open(res.data, "_blank").focus();
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
    downloadZIP(item) {
  this.sending = true;
  let data = { idStudy: item.idStudy };
  DownloadZipRequest.downloadImagesDCM(data)
    .then((res) => {
      // Construir el nombre del archivo con el formato: ApellidosNombres - ID.zip
      let filename = '';
      
      if (item.fullNamePatient && item.idPatient) {
        const nameParts = item.fullNamePatient.trim().split(/\s+/).filter(part => part !== '');
        const numParts = nameParts.length;
        
        if (numParts === 1) {
          filename = `${nameParts[0]} - ${item.idPatient}.zip`;
        } else {
          // Lógica corregida: determinar cuántos apellidos tiene
          let apellidosCount;
          
          if (numParts === 2) {
            apellidosCount = 1;
          } else if (numParts === 3) {
            apellidosCount = 2;
          } else if (numParts === 4) {
            apellidosCount = 2;
          } else {
            apellidosCount = 2;
          }
          
          // Tomar los últimos elementos como apellidos
          const apellidos = nameParts.slice(-apellidosCount).join('');
          // Tomar los primeros elementos como nombres
          const nombres = nameParts.slice(0, -apellidosCount).join('');
          
          // Formato: Apellidos + Nombres
          filename = `${apellidos}${nombres} - ${item.idPatient}.zip`;
        }
      } else {
        filename = `Estudio-${item.idStudy}.zip`;
      }

      const url = URL.createObjectURL(
        new Blob([res.data], {
          type: "application/zip",
        })
      );

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      
      // Liberar memoria después de un tiempo
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 60000);
    })
    .catch(this.catchError)
    .finally(() => {
      this.sending = false;
    });
},
    viewerOsirix(item) {
      this.sending = true;
      let data = { idStudy: item.idStudy };
      ConfigurationService.findConfigurationOsirixPath(data).then((res) => {
        window.open(res.data, "_blank").focus();
      }).catch((error) => {
        UtilFront.errorhttp(error);
      })
        .finally(() => {
          this.sending = false;
        });
    },
    openDialog(typeDialog) {
      this.typeDialog = typeDialog;
      this.dialog = true;
    },
    downloadInterpretation() {
  this.sending = true;
  
  // Construir el nombre del archivo con el formato: ApellidosNombres - ID.pdf
  let filename = '';
  let displayName = '';
  
  if (this.model.fullNamePatient && this.model.idPatient) {
    const nameParts = this.model.fullNamePatient.trim().split(/\s+/).filter(part => part !== '');
    const numParts = nameParts.length;
    
    if (numParts === 1) {
      filename = `${nameParts[0]} - ${this.model.idPatient}.pdf`;
      displayName = `${nameParts[0]} - ${this.model.idPatient}`;
    } else {
      // Lógica corregida: determinar cuántos apellidos tiene
      // Para español: los apellidos suelen ser los últimos elementos
      let apellidosCount;
      
      if (numParts === 2) {
        // Ejemplo: "Juan Pérez" -> 1 apellido, 1 nombre
        apellidosCount = 1;
      } else if (numParts === 3) {
        // Ejemplo: "María García López" -> 2 apellidos, 1 nombre
        apellidosCount = 2;
      } else if (numParts === 4) {
        // Ejemplo: "José Luis Hernández García" -> 2 apellidos, 2 nombres
        apellidosCount = 2;
      } else {
        // Para 5+ partes: 2 apellidos, el resto nombres
        apellidosCount = 2;
      }
      
      // Tomar los últimos elementos como apellidos
      const apellidos = nameParts.slice(-apellidosCount).join('');
      // Tomar los primeros elementos como nombres
      const nombres = nameParts.slice(0, -apellidosCount).join('');
      
      // Formato: Apellidos + Nombres
      filename = `${apellidos}${nombres} - ${this.model.idPatient}.pdf`;
      displayName = `${apellidos}${nombres} - ${this.model.idPatient}`;
    }
  } else {
    filename = `Interpretacion-${this.model.idStudy}.pdf`;
    displayName = `Interpretacion-${this.model.idStudy}`;
  }

  let data = {
    idInterpretation: null,
    interpretationText: this.interpretation,
    complement: this.model.complement,
    idStudy: this.model.idStudy,
    fileName: filename,
    idBirads: this?.model?.birads?.idBirads
  };
  
  ReportPDFRequest.downloadInterpretation1(data).then((res) => {
    if (res.status == 200 && res.data.type != "application/json") {
      const pdfBlob = new Blob([res.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // Crear una página HTML que muestre el PDF con el título personalizado
      const htmlContent = `
<!DOCTYPE html>
<html>
<head>
    <title>${displayName}</title>
    <style>
        body, html {
            margin: 0;
            padding: 0;
            height: 100%;
            overflow: hidden;
        }
        embed {
            width: 100%;
            height: 100%;
            border: none;
        }
    </style>
</head>
<body>
    <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%">
</body>
</html>`;

      const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
      const htmlUrl = URL.createObjectURL(htmlBlob);

      // Abrir la página HTML en una nueva pestaña
      window.open(htmlUrl, '_blank');

      // También ofrecer la descarga directa con el nombre correcto
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Limpiar las URLs después de un tiempo
      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
        URL.revokeObjectURL(htmlUrl);
      }, 60000);
    } else {
      this.$utilFront.displayErrorPdf(res.data);
    }
  });
  this.sending = false;
},
    async openPDF(file) {
      let w = window.open("about:blank");
      setTimeout(function () {
        w?.document.write(`
            <!DOCTYPE html>
              <head>
              <title>Informe</title>
              </head>
              <body>
              <img src="${file.url}" width="70%">
              </body>
            </html>`);
      }, 0);
    },
    addImageToList(n) {
      if (n.added) {
        let indexSearch = this.imagesToAdd.indexOf(n);
        if (indexSearch == -1) {
          this.imagesToAdd.push(n);
        }
      } else {
        let indexSearchRemove = this.imagesToAdd.indexOf(n);
        if (indexSearchRemove > -1) {
          this.imagesToAdd.splice(indexSearchRemove, 1);
        }
      }
     
    },
    addImages() {

      let imagetoupload = this.imagesToAdd;
      this.imagesToAdd = [];

      console.log(this.imagesToAdd);
      console.log(imagetoupload);

      if (this.flag == 0) {
        this.listaddedImages = imagetoupload;
        let tableHTML = `<p style='display: flex; flex-wrap: wrap; align-items: center; justify-content: center;'>`;
        for (let i in this.listaddedImages) {
          const element = this.listaddedImages[i];
          let imageHTML = `<img src='${element.url}' style='width: 250px; margin:10px'/>`;
          tableHTML += `${imageHTML}`;
        }
        tableHTML += `</p>`;
        let interpretationHTML = this.interpretation;
        interpretationHTML += tableHTML;
        this.interpretation = interpretationHTML;
        this.model.interpretation = this.interpretation;
        this.flag = 1;
      } else if (this.flag == 1) {
        let tableHTML = `<p style='display: flex; flex-wrap: wrap; align-items: center; justify-content: center;'>`;
        for (let i in imagetoupload) {
          const element = imagetoupload[i];
          let imageHTML = `<img src='${element.url}' style='width: 250px; margin:10px'/>`;
          tableHTML += `${imageHTML}`;
        }
        tableHTML += `</p>`;
        let interpretationHTML = this.interpretation;
        interpretationHTML += tableHTML;
        this.interpretation = interpretationHTML;
        this.model.interpretation = this.interpretation;
      }
      console.log(this.interpretation);
      this.dialogImages = false;
    },
    handlePatientLoaded(patientData) {
    this.model.idPerson = patientData.person.id;
  },
  },
};
</script>

<style></style>
